import { StrictNullable } from '@/shared/types/app.types'
import { store } from '@/store/store'
import { AccountingUnitResponse } from '@/api/services/billing/common-accounting-unit/billing-common-accounting-unit.dto'
import { BillableRateCopaymentType } from '@/modules/configurationModule/detail/local-accounting/billable/rates/services/configuration-local-accounting-billable-rates/billable-rate.dto'
import i18n from '@/lang/i18n'
import { SimpleListResponse } from '@/api/services/common/simple-list/common-simple-list.dto'

export interface ConfigurationLocalAccountingRatesModalBasicFormInvoiceToListValue extends SimpleListResponse {
    id: BillableRateCopaymentType
}
export interface ConfigurationLocalAccountingRatesModalBasicFormValues {
    id?: number
    name: string
    code: string
    startDate: StrictNullable<Date>
    endDate: StrictNullable<Date>
    isDefault: boolean
    allowsCopayment: boolean
    copaymentType: StrictNullable<ConfigurationLocalAccountingRatesModalBasicFormInvoiceToListValue>
    accountingUnit: StrictNullable<AccountingUnitResponse>
}
export interface ConfigurationLocalAccountingRatesModalBasicFormState {
    rate: ConfigurationLocalAccountingRatesModalBasicFormValues
    laboratoryId: number
    todayDate: Date
    finishDate: Date
    units: AccountingUnitResponse[]
    invoiceToList: ConfigurationLocalAccountingRatesModalBasicFormInvoiceToListValue[]
}

export const configurationLocalAccountingRatesModalBasicFormInvoiceListValues =
    (): ConfigurationLocalAccountingRatesModalBasicFormInvoiceToListValue[] => [
        {
            id: BillableRateCopaymentType.PATIENT,
            label: i18n.tc('entities.coreEntities.patient')
        },
        {
            id: BillableRateCopaymentType.CUSTOMER,
            label: i18n.tc('accounting.field.client')
        }
    ]

export const initialLocalAccountingRatesModalBasicFormState =
    (): ConfigurationLocalAccountingRatesModalBasicFormState => {
        const today = new Date()
        const finishDate = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate())
        return {
            rate: {
                code: '',
                isDefault: false,
                allowsCopayment: false,
                name: '',
                startDate: today,
                endDate: finishDate,
                accountingUnit: null,
                copaymentType: configurationLocalAccountingRatesModalBasicFormInvoiceListValues()[0]
            },
            laboratoryId: store.getters.labId,
            todayDate: today,
            finishDate: finishDate,
            units: [],
            invoiceToList: configurationLocalAccountingRatesModalBasicFormInvoiceListValues()
        }
    }
